export default "__VITE_ASSET__ByGmjRpt__"